import React from "react";
import { AlertTriangle, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { formatError } from "@/lib/api";

/**
 * Compact error card used inside a dashboard widget / list.
 * Never renders a raw error object.
 */
export function WidgetError({ error, onRetry, title = "Could not load", testId }) {
  return (
    <div
      data-testid={testId || "widget-error"}
      className="bg-white border border-red-200 rounded p-4 text-sm"
    >
      <div className="flex items-start gap-2 text-red-700">
        <AlertTriangle size={16} className="mt-0.5 shrink-0" />
        <div className="min-w-0">
          <div className="font-semibold">{title}</div>
          <div className="text-slate-600 mt-1 break-words">
            {formatError(error, "Please try again.")}
          </div>
        </div>
      </div>
      {onRetry && (
        <Button
          data-testid={`${testId || "widget-error"}-retry`}
          onClick={onRetry}
          variant="outline"
          className="rounded mt-3 h-8 px-3 text-xs flex items-center gap-1"
        >
          <RefreshCw size={12} /> Retry
        </Button>
      )}
    </div>
  );
}
